var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.106,
    height: 20,
    viewBox: "0 0 16.106 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "moving_ministry_24dp_FILL0_wght300_GRAD0_opsz24",
    d: "M60-799v-21H76.106v21H69.692v-4.894H66.414V-799Zm1.853-1.853h2.708v-4.894h6.984v4.894h2.708v-17.294h-12.4Zm2.708-7.6H66.7v-2.138H64.561Zm0-4.846H66.7v-2.138H64.561Zm4.846,4.846h2.138v-2.138H69.407Zm0-4.846h2.138v-2.138H69.407Zm-4.846,12.448v-4.894h6.984v0H64.561Z",
    transform: "translate(-60 820)",
    fill: "#1447b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgIcon);
export default __webpack_public_path__ + "static/media/org_icon.8a1dd0c9fe87d8e622e066a0e3950f55.svg";
export { ForwardRef as ReactComponent };